export const groupSizes = {
	levelSize: 24,
	btnSize: 20,
	lineOffset: 1,
};

export function setGroupSkinDefaults() {
	const compact = webix.skin.$name == "mini" || webix.skin.$name == "compact";
	groupSizes.btnSize = compact ? 18 : 20;
	groupSizes.levelSize = compact ? 22 : 24;
}
